// extracted by mini-css-extract-plugin
module.exports = {"lbl":"UploadingImg_lbl__2u3D1","badg":"UploadingImg_badg__1WKeV"};